<template>
	<div style="padding: 16px;background: #F2F7FF;border-radius: 4px;">
		<div style="display: flex;align-items: center;margin-bottom: 4px;">
			<div style="font-weight: bold;font-size: 14px;color: #333333;flex: 1;">{{ title }}</div>
			<div>
				<el-popover placement="bottom" :title="popoverTitle" width="200" trigger="click"
					:content="popoverContent">
					<img :src="require('@/assets/images/ic_tips.png')" slot="reference"
						style="width: 24px;height: 24px;cursor: pointer;" />
				</el-popover>
			</div>
		</div>
		<div style="font-size: 20px; font-weight: bold;color: #2A7AFF;margin-bottom: 16px;">
			{{ score }}
		</div>
		<div>
			<score_item_detail v-for="item in data" :key="item.GItemName" :item="item" style="margin-bottom: 8px;" />
		</div>
	</div>
</template>
<script>
	import score_item_detail from './score_item_detail.vue'
	export default {
		props: {
			title: {
				type: String,
				default: ""

			},
			score: {
				type: Number,
				default: 0

			},
			data: {
				type: Array,
				default: () => ([{
						GItemName: '',
						Value: 0
					}

				])
			},
			popoverTitle: {
				type: String,
				required: true,
				default: ""
			},
			popoverContent: {
				type: String,
				required: true,
				default: ""
			}
		},
		components: {
			score_item_detail
		}
	}
</script>